import { render } from "./Home.vue?vue&type=template&id=46248b44"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=46248b44&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46248b44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46248b44', __exports__)) {
    api.reload('46248b44', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=46248b44", () => {
    api.rerender('46248b44', render)
  })

}


export default __exports__